// Break fast
import master26_10 from "../assets/img/breakfast/breakfast_10.png";
import master26_30 from "../assets/img/breakfast/breakfast_30.png";
import master26_50 from "../assets/img/breakfast/breakfast_50.png";
import master26_100 from "../assets/img/breakfast/breakfast_100.png";
import master26_200 from "../assets/img/breakfast/breakfast_200.png";
import master26_300 from "../assets/img/breakfast/breakfast_300.png";
import master26_400 from "../assets/img/breakfast/breakfast_400.png";
import master26_500 from "../assets/img/breakfast/breakfast_500.png";
import master26_750 from "../assets/img/breakfast/breakfast_750.png";
import master26_1000 from "../assets/img/breakfast/breakfast_1000.png";

// Finishing ace
import finishing_ace_101 from "../assets/img/finishing-ace/finishing-ace-101.png";
import finishing_ace_102 from "../assets/img/finishing-ace/finishing-ace-102.png";
import finishing_ace_103 from "../assets/img/finishing-ace/finishing-ace-103.png";
import finishing_ace_104 from "../assets/img/finishing-ace/finishing-ace-104.png";
import finishing_ace_105 from "../assets/img/finishing-ace/finishing-ace-105.png";
import finishing_ace_106 from "../assets/img/finishing-ace/finishing-ace-106.png";
import finishing_ace_107 from "../assets/img/finishing-ace/finishing-ace-107.png";
import finishing_ace_108 from "../assets/img/finishing-ace/finishing-ace-108.png";
import finishing_ace_109 from "../assets/img/finishing-ace/finishing-ace-109.png";
import finishing_ace_110 from "../assets/img/finishing-ace/finishing-ace-110.png";
import finishing_ace_111 from "../assets/img/finishing-ace/finishing-ace-111.png";
import finishing_ace_112 from "../assets/img/finishing-ace/finishing-ace-112.png";
import finishing_ace_113 from "../assets/img/finishing-ace/finishing-ace-113.png";
import finishing_ace_114 from "../assets/img/finishing-ace/finishing-ace-114.png";
import finishing_ace_115 from "../assets/img/finishing-ace/finishing-ace-115.png";
import finishing_ace_116 from "../assets/img/finishing-ace/finishing-ace-116.png";
import finishing_ace_117 from "../assets/img/finishing-ace/finishing-ace-117.png";
import finishing_ace_118 from "../assets/img/finishing-ace/finishing-ace-118.png";
import finishing_ace_119 from "../assets/img/finishing-ace/finishing-ace-119.png";
import finishing_ace_120 from "../assets/img/finishing-ace/finishing-ace-120.png";
import finishing_ace_121 from "../assets/img/finishing-ace/finishing-ace-121.png";
import finishing_ace_122 from "../assets/img/finishing-ace/finishing-ace-122.png";
import finishing_ace_123 from "../assets/img/finishing-ace/finishing-ace-123.png";
import finishing_ace_124 from "../assets/img/finishing-ace/finishing-ace-124.png";
import finishing_ace_125 from "../assets/img/finishing-ace/finishing-ace-125.png";
import finishing_ace_126 from "../assets/img/finishing-ace/finishing-ace-126.png";
import finishing_ace_127 from "../assets/img/finishing-ace/finishing-ace-127.png";
import finishing_ace_128 from "../assets/img/finishing-ace/finishing-ace-128.png";
import finishing_ace_129 from "../assets/img/finishing-ace/finishing-ace-129.png";
import finishing_ace_130 from "../assets/img/finishing-ace/finishing-ace-130.png";
import finishing_ace_131 from "../assets/img/finishing-ace/finishing-ace-131.png";
import finishing_ace_132 from "../assets/img/finishing-ace/finishing-ace-132.png";
import finishing_ace_133 from "../assets/img/finishing-ace/finishing-ace-133.png";
import finishing_ace_134 from "../assets/img/finishing-ace/finishing-ace-134.png";
import finishing_ace_135 from "../assets/img/finishing-ace/finishing-ace-135.png";
import finishing_ace_136 from "../assets/img/finishing-ace/finishing-ace-136.png";
import finishing_ace_137 from "../assets/img/finishing-ace/finishing-ace-137.png";
import finishing_ace_138 from "../assets/img/finishing-ace/finishing-ace-138.png";
import finishing_ace_139 from "../assets/img/finishing-ace/finishing-ace-139.png";
import finishing_ace_140 from "../assets/img/finishing-ace/finishing-ace-140.png";
import finishing_ace_141 from "../assets/img/finishing-ace/finishing-ace-141.png";
import finishing_ace_142 from "../assets/img/finishing-ace/finishing-ace-142.png";
import finishing_ace_143 from "../assets/img/finishing-ace/finishing-ace-143.png";
import finishing_ace_144 from "../assets/img/finishing-ace/finishing-ace-144.png";
import finishing_ace_145 from "../assets/img/finishing-ace/finishing-ace-145.png";
import finishing_ace_146 from "../assets/img/finishing-ace/finishing-ace-146.png";
import finishing_ace_147 from "../assets/img/finishing-ace/finishing-ace-147.png";
import finishing_ace_148 from "../assets/img/finishing-ace/finishing-ace-148.png";
import finishing_ace_149 from "../assets/img/finishing-ace/finishing-ace-149.png";
import finishing_ace_150 from "../assets/img/finishing-ace/finishing-ace-150.png";
import finishing_ace_151 from "../assets/img/finishing-ace/finishing-ace-151.png";
import finishing_ace_152 from "../assets/img/finishing-ace/finishing-ace-152.png";
import finishing_ace_153 from "../assets/img/finishing-ace/finishing-ace-153.png";
import finishing_ace_154 from "../assets/img/finishing-ace/finishing-ace-154.png";
import finishing_ace_155 from "../assets/img/finishing-ace/finishing-ace-155.png";
import finishing_ace_156 from "../assets/img/finishing-ace/finishing-ace-156.png";
import finishing_ace_157 from "../assets/img/finishing-ace/finishing-ace-157.png";
import finishing_ace_158 from "../assets/img/finishing-ace/finishing-ace-158.png";
import finishing_ace_160 from "../assets/img/finishing-ace/finishing-ace-160.png";
import finishing_ace_161 from "../assets/img/finishing-ace/finishing-ace-161.png";
import finishing_ace_164 from "../assets/img/finishing-ace/finishing-ace-164.png";
import finishing_ace_167 from "../assets/img/finishing-ace/finishing-ace-167.png";
import finishing_ace_170 from "../assets/img/finishing-ace/finishing-ace-170.png";

// friendly challenger
import friendly_challenger_1 from "../assets/img/friendly_challenger/friendly_challenger_1.png";
import friendly_challenger_5 from "../assets/img/friendly_challenger/friendly_challenger_5.png";
import friendly_challenger_10 from "../assets/img/friendly_challenger/friendly_challenger_10.png";
import friendly_challenger_20 from "../assets/img/friendly_challenger/friendly_challenger_20.png";
import friendly_challenger_50 from "../assets/img/friendly_challenger/friendly_challenger_50.png";

// streak
import streak_1 from "../assets/img/streak/1_VICTORY_STREAK.png";
import streak_2 from "../assets/img/streak/2_VICTORY_STREAK.png";
import streak_3 from "../assets/img/streak/3_VICTORY_STREAK.png";
import streak_4 from "../assets/img/streak/4_VICTORY_STREAK.png";
import streak_5 from "../assets/img/streak/5_VICTORY_STREAK.png";

// pyramid_climber
import pyramid_climber_1 from "../assets/img/pyramid_climber/pyramide_climber_1.png";
import pyramid_climber_3 from "../assets/img/pyramid_climber/pyramide_climber_3.png";
import pyramid_climber_5 from "../assets/img/pyramid_climber/pyramide_climber_5.png";
import pyramid_climber_10 from "../assets/img/pyramid_climber/pyramide_climber_10.png";
import pyramid_climber_15 from "../assets/img/pyramid_climber/pyramide_climber_15.png";

// monthly_maestro
import monthly_maestro_1 from "../assets/img/monthly_maestro/monthly_maestro_1.png";
import monthly_maestro_2 from "../assets/img/monthly_maestro/monthly_maestro_2.png";
import monthly_maestro_3 from "../assets/img/monthly_maestro/monthly_maestro_3.png";
import monthly_maestro_4 from "../assets/img/monthly_maestro/monthly_maestro_4.png";
import monthly_maestro_5 from "../assets/img/monthly_maestro/monthly_maestro_5.png";
import monthly_maestro_6 from "../assets/img/monthly_maestro/monthly_maestro_6.png";
import monthly_maestro_7 from "../assets/img/monthly_maestro/monthly_maestro_7.png";
import monthly_maestro_8 from "../assets/img/monthly_maestro/monthly_maestro_8.png";
import monthly_maestro_9 from "../assets/img/monthly_maestro/monthly_maestro_9.png";

// pyraid protector
import pyramid_protector_1 from "../assets/img/pyramid_protector/pyramide_protector_1.png";
import pyramid_protector_3 from "../assets/img/pyramid_protector/pyramide_protector_3.png";
import pyramid_protector_5 from "../assets/img/pyramid_protector/pyramide_protector_5.png";
import pyramid_protector_10 from "../assets/img/pyramid_protector/pyramide_protector_10.png";
import pyramid_protector_15 from "../assets/img/pyramid_protector/pyramide_protector_15.png";

// legendary rivalry
import legendary_rivalry_2 from "../assets/img/legendary_rivalry/2ACHIEV_LEGENDARY_RIVALRY.png";
import legendary_rivalry_3 from "../assets/img/legendary_rivalry/3ACHIEV_LEGENDARY_RIVALRY.png";
import legendary_rivalry_4 from "../assets/img/legendary_rivalry/4ACHIEV_LEGENDARY_RIVALRY.png";
import legendary_rivalry_5 from "../assets/img/legendary_rivalry/5ACHIEV_LEGENDARY_RIVALRY.png";
import legendary_rivalry_6 from "../assets/img/legendary_rivalry/6ACHIEV_LEGENDARY_RIVALRY.png";

// iron dart
import iron_dart_10 from "../assets/img/iron_dart/iron_dart_10.png";
import iron_dart_20 from "../assets/img/iron_dart/iron_dart_20.png";
import iron_dart_30 from "../assets/img/iron_dart/iron_dart_30.png";
import iron_dart_40 from "../assets/img/iron_dart/iron_dart_40.png";
import iron_dart_50 from "../assets/img/iron_dart/iron_dart_50.png";
import iron_dart_60 from "../assets/img/iron_dart/iron_dart_60.png";
import iron_dart_70 from "../assets/img/iron_dart/iron_dart_70.png";
import iron_dart_80 from "../assets/img/iron_dart/iron_dart_80.png";
import iron_dart_90 from "../assets/img/iron_dart/iron_dart_90.png";
import iron_dart_100 from "../assets/img/iron_dart/iron_dart_100.png";

// 180 master
import master_180_1 from "../assets/img/180_master/master_180_1.png";
import master_180_3 from "../assets/img/180_master/master_180_3.png";
import master_180_5 from "../assets/img/180_master/master_180_5.png";
import master_180_10 from "../assets/img/180_master/master_180_10.png";
import master_180_20 from "../assets/img/180_master/master_180_20.png";
import master_180_100 from "../assets/img/180_master/master_180_100.png";

// consistent scorer
import consistent_scorer_3 from "../assets/img/consistent_scorer/consistent_scorer_3.png";
import consistent_scorer_5 from "../assets/img/consistent_scorer/consistent_scorer_5.png";
import consistent_scorer_10 from "../assets/img/consistent_scorer/consistent_scorer_10.png";
import consistent_scorer_20 from "../assets/img/consistent_scorer/consistent_scorer_20.png";
import consistent_scorer_50 from "../assets/img/consistent_scorer/consistent_scorer_50.png";

// grand master
import rounder_8_leg from "../assets/img/grandmaster_average/rounder_8_leg.png";
import rounder_8_match from "../assets/img/grandmaster_average/rounder_8_match.png";
import high_scorer_leg_90 from "../assets/img/grandmaster_average/high_scorer_leg_90.png";
import high_scorer_match_90 from "../assets/img/grandmaster_average/high_scorer_match_90.png";
import luke_middler_leg from "../assets/img/grandmaster_average/luke_middler_leg.png";
import luke_middler_match from "../assets/img/grandmaster_average/luke_middler_match.png";
import scorer_leg_70 from "../assets/img/grandmaster_average/scorer_leg_70.png";
import scorer_match_70 from "../assets/img/grandmaster_average/scorer_match_70.png";
import tripel_digit_dynamo_leg from "../assets/img/grandmaster_average/tripel_digit_dynamo_leg.png";
import tripel_digit_dynamo_match from "../assets/img/grandmaster_average/tripel_digit_dynamo_match.png";
import zenturio_leg from "../assets/img/grandmaster_average/zenturio_leg.png";
import zenturio_match from "../assets/img/grandmaster_average/zenturio_match.png";

// maximum marksman
import MAXIMUMMARKSMAN from "../assets/img/maximum_marksman.png";

// dart enthusiast
import dart_enthusiast_1 from "../assets/img/dart_enthusiast/dart_enthusiast_1.png";
import dart_enthusiast_2 from "../assets/img/dart_enthusiast/dart_enthusiast_2.png";
import dart_enthusiast_3 from "../assets/img/dart_enthusiast/dart_enthusiast_3.png";
import dart_enthusiast_4 from "../assets/img/dart_enthusiast/dart_enthusiast_4.png";
import dart_enthusiast_5 from "../assets/img/dart_enthusiast/dart_enthusiast_5.png";
import dart_enthusiast_6 from "../assets/img/dart_enthusiast/dart_enthusiast_6.png";
import dart_enthusiast_7 from "../assets/img/dart_enthusiast/dart_enthusiast_7.png";
import dart_enthusiast_8 from "../assets/img/dart_enthusiast/dart_enthusiast_8.png";
import dart_enthusiast_9 from "../assets/img/dart_enthusiast/dart_enthusiast_9.png";
import dart_enthusiast_10 from "../assets/img/dart_enthusiast/dart_enthusiast_10.png";

// ready for it
import com_ready_for_it_1 from "../assets/img/ready_for_it/com_ready_for_it_1.png";
import com_ready_for_it_3 from "../assets/img/ready_for_it/com_ready_for_it_3.png";
import com_ready_for_it_5 from "../assets/img/ready_for_it/com_ready_for_it_5.png";
import com_ready_for_it_10 from "../assets/img/ready_for_it/com_ready_for_it_10.png";
import com_ready_for_it_20 from "../assets/img/ready_for_it/com_ready_for_it_20.png";

import CHAMPIONCHALLENGER from "../assets/img/champion+challenger.png";

// challenge conqueror
import challenge_conqueror_1 from "../assets/img/challenge_conqueror/1_CHALLENGE_CONQUEROR.png";
import challenge_conqueror_3 from "../assets/img/challenge_conqueror/3_CHALLENGE-CONQUEROR.png";
import challenge_conqueror_5 from "../assets/img/challenge_conqueror/5_CHALLENGE-CONQUEROR.png";
import challenge_conqueror_10 from "../assets/img/challenge_conqueror/10_CHALLENGE_CONQUEROR.png";
import challenge_conqueror_15 from "../assets/img/challenge_conqueror/15_CHALLENGE_CONQUEROR.png";

// hunter
import hunter_5 from "../assets/img/hunter/5achiev_player.png";
import hunter_10 from "../assets/img/hunter/10achiev_serious_player.png";
import hunter_15 from "../assets/img/hunter/15achiev_here_to_stay.png";
import hunter_20 from "../assets/img/hunter/20achiev_rising_fighter.png";
import hunter_25 from "../assets/img/hunter/25ACHIEV_FIGHTER.png";
import hunter_30 from "../assets/img/hunter/30achiev_underdog_fighter.png";
import hunter_40 from "../assets/img/hunter/40ACHIEV_STREET_CHALLENGER.png";
import hunter_50 from "../assets/img/hunter/50ACHIEV_ARENA_CONTENDER.png";
import hunter_60 from "../assets/img/hunter/60ACHIEV_CAGE_FIGHTER.png";
import hunter_70 from "../assets/img/hunter/70ACHIEV_UNDERGROUND_COMBATANT.png";
import hunter_80 from "../assets/img/hunter/80ACHIEV_RUTHLESS_BRAWLER.png";
import hunter_90 from "../assets/img/hunter/90ACHIEV_FIGHT_CLUB_WARRIOR.png";
import hunter_100 from "../assets/img/hunter/100ACHIEV_PIT_CHALLENGER.png";
import hunter_110 from "../assets/img/hunter/110ACHIEV_ENFORCER.png";
import hunter_120 from "../assets/img/hunter/120ACHIEV_GLADIATOR.png";
import hunter_130 from "../assets/img/hunter/130ACHIEV_MASTER_OF_THE_PIT.png";
import hunter_140 from "../assets/img/hunter/140_LEGEND_OF_THE_ARENA.png";
import hunter_150 from "../assets/img/hunter/150ACHIEV_IMMORTAL_FIGHTER.png";
import hunter_160 from "../assets/img/hunter/160ACHIEV_ULTIMATE_FIGHT_CLUB_LEGEND.png";

// ranking images
import ranking_1 from "../assets/img/first.png";
import ranking_2 from "../assets/img/second.png";
import ranking_3 from "../assets/img/third.png";
import ranking_4 from "../assets/img/fourth.png";

// crown
import GOLDCROWN from "../assets/img/gold_crown.png";
import SILVERCROWN from "../assets/img/silver_crown.png";

import SNDBADGE from "../assets/img/snd_badge.png";

import TROPHY from "../assets/img/trophy.png";
import TROPHY2 from "../assets/img/trophy2.png";

import BEGINNER from "../assets/img/new.png";

import TOPPLACE from "../assets/img/top_place.png";
import TOPPLACE2 from "../assets/img/top_place2.png";

import BOARD1 from "../assets/img/dart_board/board1.png";
import BOARD2 from "../assets/img/dart_board/board_2.png";
import BOARD3 from "../assets/img/dart_board/board_3.png";
import BOARD4 from "../assets/img/dart_board/board_4.png";

import LOGO from "../assets/img/fc_logo.png";
import LOGO1 from "../assets/img/logo1.png";

import MOVIE from "../assets/img/movie.png";

import FIRSTMEDAL from "../assets/img/first_medal.png";

import BGSUMMARY from "../assets/img/bg_summary.jpg";

import SEASONBG from "../assets/img/season_bg.png";

import HOMESLIDER1 from "../assets/img/home_slider1.png";
import HOMESLIDER2 from "../assets/img/home_slider2.png";
import HOMESLIDER3 from "../assets/img/home_slider3.png";
import HOMESLIDER4 from "../assets/img/home_slider4.png";

import HOMEQUOTE1 from "../assets/img/home_quote1.png";
import HOMEQUOTE2 from "../assets/img/home_quote2.png";

import HOMESCHEDULEBG from "../assets/img/home_schedule_img.png";

import SEASONCOUTER from "../assets/img/season_counter.png";
import LIFETIMECOUNTER from "../assets/img/lifetime_counter.png";
import BGCOUNTER1 from "../assets/img/counter1.png";
import BGCOUNTER2 from "../assets/img/counter2.png";

import RANKAVATAR1_1 from "../assets/img/avatar/LVL1/LVL_1-1.png";
import RANKAVATAR1_2 from "../assets/img/avatar/LVL1/LVL_1-2.png";
import RANKAVATAR1_3 from "../assets/img/avatar/LVL1/LVL_1-3.png";
import RANKAVATAR1_4 from "../assets/img/avatar/LVL1/LVL_1-4.png";
import RANKAVATAR1_5 from "../assets/img/avatar/LVL1/LVL_1-5.png";
import RANKAVATAR1_6 from "../assets/img/avatar/LVL1/LVL_1-6.png";
import RANKAVATAR1_7 from "../assets/img/avatar/LVL1/LVL_1-7.png";
import RANKAVATAR2_1 from "../assets/img/avatar/LVL2/LVL_2-1.png";
import RANKAVATAR2_2 from "../assets/img/avatar/LVL2/LVL_2-2.png";
import RANKAVATAR2_3 from "../assets/img/avatar/LVL2/LVL_2-3.png";
import RANKAVATAR2_4 from "../assets/img/avatar/LVL2/LVL_2-4.png";
import RANKAVATAR2_5 from "../assets/img/avatar/LVL2/LVL_2-5.png";
import RANKAVATAR2_6 from "../assets/img/avatar/LVL2/LVL_2-6.png";
import RANKAVATAR2_7 from "../assets/img/avatar/LVL2/LVL_2-7.png";
import RANKAVATAR3_1 from "../assets/img/avatar/LVL3/LVL_3-1.png";
import RANKAVATAR3_2 from "../assets/img/avatar/LVL3/LVL_3-2.png";
import RANKAVATAR3_3 from "../assets/img/avatar/LVL3/LVL_3-3.png";
import RANKAVATAR3_4 from "../assets/img/avatar/LVL3/LVL_3-4.png";
import RANKAVATAR3_5 from "../assets/img/avatar/LVL3/LVL_3-5.png";
import RANKAVATAR3_6 from "../assets/img/avatar/LVL3/LVL_3-6.png";
import RANKAVATAR3_7 from "../assets/img/avatar/LVL3/LVL_3-7.png";
import RANKAVATAR4_1 from "../assets/img/avatar/LVL4/LVL_4-1.png";
import RANKAVATAR4_2 from "../assets/img/avatar/LVL4/LVL_4-2.png";
import RANKAVATAR4_3 from "../assets/img/avatar/LVL4/LVL_4-3.png";
import RANKAVATAR4_4 from "../assets/img/avatar/LVL4/LVL_4-4.png";
import RANKAVATAR4_5 from "../assets/img/avatar/LVL4/LVL_4-5.png";
import RANKAVATAR4_6 from "../assets/img/avatar/LVL4/LVL_4-6.png";
import RANKAVATAR4_7 from "../assets/img/avatar/LVL4/LVL_4-7.png";
import RANKAVATAR5_1 from "../assets/img/avatar/LVL5/LVL_5-1.png";
import RANKAVATAR5_2 from "../assets/img/avatar/LVL5/LVL_5-2.png";
import RANKAVATAR5_3 from "../assets/img/avatar/LVL5/LVL_5-3.png";
import RANKAVATAR5_4 from "../assets/img/avatar/LVL5/LVL_5-4.png";
import RANKAVATAR5_5 from "../assets/img/avatar/LVL5/LVL_5-5.png";
import RANKAVATAR5_6 from "../assets/img/avatar/LVL5/LVL_5-6.png";
import RANKAVATAR5_7 from "../assets/img/avatar/LVL5/LVL_5-7.png";
import RANKAVATAR6_1 from "../assets/img/avatar/LVL6/LVL_6-1.png";
import RANKAVATAR6_2 from "../assets/img/avatar/LVL6/LVL_6-2.png";
import RANKAVATAR6_3 from "../assets/img/avatar/LVL6/LVL_6-3.png";
import RANKAVATAR6_4 from "../assets/img/avatar/LVL6/LVL_6-4.png";
import RANKAVATAR6_5 from "../assets/img/avatar/LVL6/LVL_6-5.png";
import RANKAVATAR6_6 from "../assets/img/avatar/LVL6/LVL_6-6.png";
import RANKAVATAR6_7 from "../assets/img/avatar/LVL6/LVL_6-7.png";

import ARENAREPLYBG from "../assets/img/Arena_one.jpg";

import JACKSVICTORY from "../assets/img/i_am_jacks_victory.jpg";
import MAYHEMWEEK from "../assets/img/mayhem_master.jpg";

import LASTTOPBG from "../assets/img/pyramid-bg.png";

// Breakfast image
const MASTER26 = [
  master26_10,
  master26_30,
  master26_50,
  master26_100,
  master26_200,
  master26_300,
  master26_400,
  master26_500,
  master26_750,
  master26_1000,
];

// Finishing Ace image
const FINISHING_ACE = [
  finishing_ace_101,
  finishing_ace_102,
  finishing_ace_103,
  finishing_ace_104,
  finishing_ace_105,
  finishing_ace_106,
  finishing_ace_107,
  finishing_ace_108,
  finishing_ace_109,
  finishing_ace_110,
  finishing_ace_111,
  finishing_ace_112,
  finishing_ace_113,
  finishing_ace_114,
  finishing_ace_115,
  finishing_ace_116,
  finishing_ace_117,
  finishing_ace_118,
  finishing_ace_119,
  finishing_ace_120,
  finishing_ace_121,
  finishing_ace_122,
  finishing_ace_123,
  finishing_ace_124,
  finishing_ace_125,
  finishing_ace_126,
  finishing_ace_127,
  finishing_ace_128,
  finishing_ace_129,
  finishing_ace_130,
  finishing_ace_131,
  finishing_ace_132,
  finishing_ace_133,
  finishing_ace_134,
  finishing_ace_135,
  finishing_ace_136,
  finishing_ace_137,
  finishing_ace_138,
  finishing_ace_139,
  finishing_ace_140,
  finishing_ace_141,
  finishing_ace_142,
  finishing_ace_143,
  finishing_ace_144,
  finishing_ace_145,
  finishing_ace_146,
  finishing_ace_147,
  finishing_ace_148,
  finishing_ace_149,
  finishing_ace_150,
  finishing_ace_151,
  finishing_ace_152,
  finishing_ace_153,
  finishing_ace_154,
  finishing_ace_155,
  finishing_ace_156,
  finishing_ace_157,
  finishing_ace_158,
  finishing_ace_160,
  finishing_ace_161,
  finishing_ace_164,
  finishing_ace_167,
  finishing_ace_170,
];

// Friendly Challenger Image
const FRIENDLYCHALLENGER = [
  friendly_challenger_1,
  friendly_challenger_5,
  friendly_challenger_10,
  friendly_challenger_20,
  friendly_challenger_50,
];

// Streak Image
const MAXVICTORYSTREAK = [streak_1, streak_2, streak_3, streak_4, streak_5];

// Pyramid Climber
const PYRAMIDCLIMBER = [
  pyramid_climber_1,
  pyramid_climber_3,
  pyramid_climber_5,
  pyramid_climber_10,
  pyramid_climber_15,
];

// Monthly Maestro
const MONTHLYMAESTRO = [
  monthly_maestro_1,
  monthly_maestro_2,
  monthly_maestro_3,
  monthly_maestro_4,
  monthly_maestro_5,
  monthly_maestro_6,
  monthly_maestro_7,
  monthly_maestro_8,
  monthly_maestro_9,
];

// Pyramid Protector
const PYRAMIDPROTECTOR = [
  pyramid_protector_1,
  pyramid_protector_3,
  pyramid_protector_5,
  pyramid_protector_10,
  pyramid_protector_15,
];

// Legendary Livalry
const LEGENDARYRIVALRY = [
  legendary_rivalry_2,
  legendary_rivalry_3,
  legendary_rivalry_4,
  legendary_rivalry_5,
  legendary_rivalry_6,
];

// Iron Dart
const IRONDART = [
  iron_dart_10,
  iron_dart_20,
  iron_dart_30,
  iron_dart_40,
  iron_dart_50,
  iron_dart_60,
  iron_dart_70,
  iron_dart_80,
  iron_dart_90,
  iron_dart_100,
];

// Master 180
const MASTER180 = [
  master_180_1,
  master_180_3,
  master_180_5,
  master_180_10,
  master_180_20,
  master_180_100,
];

// Consistent Scorer
const CONSISTENTSCORER = [
  consistent_scorer_3,
  consistent_scorer_5,
  consistent_scorer_10,
  consistent_scorer_20,
  consistent_scorer_50,
];

// Grandmaster Average
const GRANDMASTERAVERAGE = {
  grand_50_leg: luke_middler_leg,
  grand_50_match: luke_middler_match,
  grand_60_leg: rounder_8_leg,
  grand_60_match: rounder_8_match,
  grand_70_leg: scorer_leg_70,
  grand_70_match: scorer_match_70,
  grand_90_leg: high_scorer_leg_90,
  grand_90_match: high_scorer_match_90,
  grand_100_leg: zenturio_leg,
  grand_100_match: zenturio_match,
  grand_110_leg: tripel_digit_dynamo_leg,
  grand_110_match: tripel_digit_dynamo_match,
};

// Dart Enthusiast
const DARTENTHUSIAST = [
  dart_enthusiast_1,
  dart_enthusiast_2,
  dart_enthusiast_3,
  dart_enthusiast_4,
  dart_enthusiast_5,
  dart_enthusiast_6,
  dart_enthusiast_7,
  dart_enthusiast_8,
  dart_enthusiast_9,
  dart_enthusiast_10,
];

// Ready For It
const READYFORIT = [
  com_ready_for_it_1,
  com_ready_for_it_3,
  com_ready_for_it_5,
  com_ready_for_it_10,
  com_ready_for_it_20,
];

// Challenge Challenger
const CHALLENGECONQUEROR = [
  challenge_conqueror_1,
  challenge_conqueror_3,
  challenge_conqueror_5,
  challenge_conqueror_10,
  challenge_conqueror_15,
];

const FINISHINGACE = [...FINISHING_ACE.reverse()];

// ranking
const RANKINGMARK = [ranking_1, ranking_2, ranking_3, ranking_4];

// Hunter
const HUNTER = {
  hunter_5,
  hunter_10,
  hunter_15,
  hunter_20,
  hunter_25,
  hunter_30,
  hunter_40,
  hunter_50,
  hunter_60,
  hunter_70,
  hunter_80,
  hunter_90,
  hunter_100,
  hunter_110,
  hunter_120,
  hunter_130,
  hunter_140,
  hunter_150,
  hunter_160,
};

const VAVATAR = {
  RANKAVATAR1_1,
  RANKAVATAR1_2,
  RANKAVATAR1_3,
  RANKAVATAR1_4,
  RANKAVATAR1_5,
  RANKAVATAR1_6,
  RANKAVATAR1_7,
  RANKAVATAR2_1,
  RANKAVATAR2_2,
  RANKAVATAR2_3,
  RANKAVATAR2_4,
  RANKAVATAR2_5,
  RANKAVATAR2_6,
  RANKAVATAR2_7,
  RANKAVATAR3_1,
  RANKAVATAR3_2,
  RANKAVATAR3_3,
  RANKAVATAR3_4,
  RANKAVATAR3_5,
  RANKAVATAR3_6,
  RANKAVATAR3_7,
  RANKAVATAR4_1,
  RANKAVATAR4_2,
  RANKAVATAR4_3,
  RANKAVATAR4_4,
  RANKAVATAR4_5,
  RANKAVATAR4_6,
  RANKAVATAR4_7,
  RANKAVATAR5_1,
  RANKAVATAR5_2,
  RANKAVATAR5_3,
  RANKAVATAR5_4,
  RANKAVATAR5_5,
  RANKAVATAR5_6,
  RANKAVATAR5_7,
  RANKAVATAR6_1,
  RANKAVATAR6_2,
  RANKAVATAR6_3,
  RANKAVATAR6_4,
  RANKAVATAR6_5,
  RANKAVATAR6_6,
  RANKAVATAR6_7,
};

const images = {
  MAXVICTORYSTREAK,
  FRIENDLYCHALLENGER,
  FINISHINGACE,
  MASTER26,
  PYRAMIDCLIMBER,
  MONTHLYMAESTRO,
  PYRAMIDPROTECTOR,
  LEGENDARYRIVALRY,
  IRONDART,
  MASTER180,
  CONSISTENTSCORER,
  GRANDMASTERAVERAGE,
  MAXIMUMMARKSMAN,
  DARTENTHUSIAST,
  READYFORIT,
  CHAMPIONCHALLENGER,
  CHALLENGECONQUEROR,
  HUNTER,
  RANKINGMARK,
  GOLDCROWN,
  SILVERCROWN,
  TROPHY,
  TROPHY2,
  BEGINNER,
  SNDBADGE,
  TOPPLACE,
  TOPPLACE2,
  BOARD1,
  BOARD2,
  BOARD3,
  BOARD4,
  LOGO,
  LOGO1,
  MOVIE,
  BGSUMMARY,
  FIRSTMEDAL,
  SEASONBG,
  HOMESLIDER1,
  HOMESLIDER2,
  HOMESLIDER3,
  HOMESLIDER4,
  HOMEQUOTE1,
  HOMEQUOTE2,
  HOMESCHEDULEBG,
  SEASONCOUTER,
  LIFETIMECOUNTER,
  VAVATAR,
  ARENAREPLYBG,
  BGCOUNTER1,
  BGCOUNTER2,
  JACKSVICTORY,
  MAYHEMWEEK,
  LASTTOPBG,
};

export default images;
